import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import buildImageUrl from '../utils/imageUrl';
import './Cart.css';

const Cart = () => {
  const { cart, removeFromCart, updateQuantity, getCartTotal } = useCart();
  const navigate = useNavigate();
  const [imageErrors, setImageErrors] = useState({});

  if (cart.length === 0) {
    return (
      <div className="empty-state">
        <h2>Your cart is empty</h2>
        <p>Add some beautiful pottery to get started!</p>
        <Link to="/ready-made" className="btn btn-primary">
          Browse Shop
        </Link>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <h1>Shopping Cart</h1>

      <div className="cart-content">
        <div className="cart-items">
          {cart.map((item) => {
            const primaryImage = item.images?.find((img) => img.is_primary) || item.images?.[0];
            const imageUrl = buildImageUrl(primaryImage?.image_url);
            const hasImageError = imageErrors[item.id];

            return (
              <div key={item.id} className="cart-item">
                <Link to={`/item/${item.id}`} className="cart-item-image">
                  {imageUrl && !hasImageError ? (
                    <img
                      src={imageUrl}
                      alt={item.name}
                      onError={() => {
                        setImageErrors((prevErrors) => ({ ...prevErrors, [item.id]: true }));
                      }}
                    />
                  ) : (
                    <div className="image-placeholder">No Image</div>
                  )}
                </Link>

                <div className="cart-item-details">
                  <Link to={`/item/${item.id}`} className="cart-item-name">
                    {item.name}
                  </Link>
                  {item.category && (
                    <p className="cart-item-category">{item.category}</p>
                  )}
                  <p className="cart-item-price">${item.price.toFixed(2)}</p>
                </div>

                <div className="cart-item-quantity">
                  <button
                    onClick={() => updateQuantity(item.id, item.quantity - 1)}
                    disabled={item.quantity <= 1}
                  >
                    -
                  </button>
                  <span>{item.quantity}</span>
                  <button
                    onClick={() => updateQuantity(item.id, item.quantity + 1)}
                    disabled={item.quantity >= item.stock_quantity}
                  >
                    +
                  </button>
                </div>

                <div className="cart-item-total">
                  ${(item.price * item.quantity).toFixed(2)}
                </div>

                <button
                  className="cart-item-remove"
                  onClick={() => removeFromCart(item.id)}
                >
                  ×
                </button>
              </div>
            );
          })}
        </div>

        <div className="cart-summary card">
          <h2>Order Summary</h2>
          <div className="summary-row">
            <span>Subtotal:</span>
            <span>${getCartTotal().toFixed(2)}</span>
          </div>
          <div className="summary-row total">
            <span>Total:</span>
            <span>${getCartTotal().toFixed(2)}</span>
          </div>
          <button
            className="btn btn-primary checkout-btn"
            onClick={() => navigate('/checkout')}
          >
            Proceed to Checkout
          </button>
          <Link to="/" className="continue-shopping">
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cart;
